import { inject, Pipe, PipeTransform } from '@angular/core';
import { AddinConfigService } from '@outlook-addin/shared';

@Pipe({
  name: 'resourceExternalUrl',
  standalone: true,
})
export class ResourceExternalUrlPipe implements PipeTransform {
  configService = inject(AddinConfigService);

  transform(resourceId: number): string {
    if (resourceId) {
      return `${this.configService.value.configuration.assistURL}/dashboard?multiviewResource=${resourceId}`;
    }
    return null;
  }
}
